
export default {
    methods:{
      test(data) {
        //console.log("test")
        //this.$socket.emit('chat message', data)
      },
      test2() {
        //console.log("FUCK")
      },
     permission_check(permission, permission_id) {
        permission = permission.split(',').map(Number)
        return permission.includes(permission_id)
      }
    },
    data() {
      return {
        reader_action : normal
      }
    }
}
